import { Link as RouterLink } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Card, Link, Container, Typography, Box } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import { Page } from "../../components/Page";
import { AdminRegisterForm } from "../../sections/auth/admin-register/index";

const RootStyle = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const HeaderStyle = styled("header")(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: "100%",
  display: "flex",
  alignItems: "center",
  position: "absolute",
  padding: theme.spacing(3),
  justifyContent: "space-between",
  [theme.breakpoints.up("md")]: {
    alignItems: "flex-start",
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: "100%",
  maxWidth: 464,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(1, 0),
}));

export default function AdminRegister() {
  // TODO configure start + end!
  const smUp = useResponsive("up", "sm", "xs", "lg");

  const mdUp = useResponsive("up", "md", "xs", "lg");

  return (
    <Page title="Register">
      <RootStyle>
        <HeaderStyle>
          {smUp && (
            <Typography variant="body2" sx={{ mt: { md: -2 }, float: "right" }}>
              Already have an account? {""}
              <Link variant="subtitle2" component={RouterLink} to="/login">
                Login
              </Link>
            </Typography>
          )}
        </HeaderStyle>

        {mdUp && (
          <SectionStyle>
            <img src="/static/images/hotel.jpg" alt="login" />
          </SectionStyle>
        )}

        <Container>
          <ContentStyle>
            <Box
              component="img"
              src="/static/images/logo.jpeg"
              sx={{ width: "100px", top: 0 }}
            />
            <Typography
              variant="h4"
              gutterBottom
              style={{ color: "blue", fontWeight: 700, fontSize: 28 }}
            >
              Welcome to RateBotAI
            </Typography>
            <Typography
              variant="h4"
              gutterBottom
              style={{ color: "blue", fontWeight: 700, fontSize: 18 }}
            >
              Admin Registration
            </Typography>
            <AdminRegisterForm />

            {!smUp && (
              <Typography variant="body2" sx={{ mt: 3, textAlign: "center" }}>
                Already have an account?{" "}
                <Link variant="subtitle2" to="/login" component={RouterLink}>
                  Login
                </Link>
              </Typography>
            )}
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
